import React from 'react';
import CheckboxMui, { CheckboxProps } from '@material-ui/core/Checkbox';

export const Checkbox: React.FC<CheckboxProps> = ({ children, ...rest }) => {
	return <CheckboxMui {...rest}>{children}</CheckboxMui>;
};
